import React from 'react'
import { useHistory } from 'react-router-dom'

import Button, { BUTTON_STYLES } from '../../common/components/Button'

import styles from './Admin.module.css'

const ListHeader = ({ title, routeName }) => {
  const history = useHistory()

  return (
    <div className={styles.listHeader}>
      <h1>{title}</h1>
      <Button
        onClick={() => history.push(`/admin/${routeName}/create`)}
        text={
          <>
            <i className="fas fa-plus"></i> Create New
          </>
        }
        style={BUTTON_STYLES.PRIMARY}
      />
    </div>
  )
}

export default ListHeader
